// Partner documentation import (back/routes/partnerImport.js), mounted at
// /projects/:projectId/partner-import. Upload is multipart ("files", many);
// everything else is JSON.
import { url, tokenRef } from "api";

const auth = () => {
  const t = localStorage.getItem(tokenRef);
  return t ? { Authorization: `Bearer ${t}` } : {};
};
const json = () => ({ ...auth(), "Content-Type": "application/json" });

async function handle(res) {
  let data = {};
  try { data = await res.json(); } catch (e) { data = {}; }
  if (!res.ok) {
    const err = new Error(data.err || "Request failed");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}
const base = (projectId) => `${url}/projects/${projectId}/partner-import`;

export const uploadPartnerDocs = async (projectId, files) => {
  const fd = new FormData();
  (files || []).forEach((f) => fd.append("files", f));
  return handle(await fetch(base(projectId), { method: "POST", headers: auth(), body: fd }));
};
export const listPartnerImports = async (projectId, status) =>
  handle(await fetch(`${base(projectId)}${status ? `?status=${encodeURIComponent(status)}` : ""}`, { headers: auth() }));
export const getPartnerImport = async (projectId, id) =>
  handle(await fetch(`${base(projectId)}/${id}`, { headers: auth() }));
export const savePartnerImportDecisions = async (projectId, id, decisions) =>
  handle(await fetch(`${base(projectId)}/${id}/decisions`, { method: "PUT", headers: json(), body: JSON.stringify({ decisions }) }));
export const previewPartnerImport = async (projectId, id, decisions) =>
  handle(await fetch(`${base(projectId)}/${id}/preview`, { method: "POST", headers: json(), body: JSON.stringify({ decisions }) }));
export const applyPartnerImport = async (projectId, id, decisions) =>
  handle(await fetch(`${base(projectId)}/${id}/apply`, { method: "POST", headers: json(), body: JSON.stringify({ decisions }) }));
export const undoPartnerImport = async (projectId, id) =>
  handle(await fetch(`${base(projectId)}/${id}/undo`, { method: "POST", headers: json(), body: "{}" }));
export const retryPartnerImport = async (projectId, id) =>
  handle(await fetch(`${base(projectId)}/${id}/retry`, { method: "POST", headers: json(), body: "{}" }));
export const dismissPartnerImport = async (projectId, id) =>
  handle(await fetch(`${base(projectId)}/${id}`, { method: "DELETE", headers: auth() }));
